export default "__VITE_ASSET__0f082701__"